import { addEventToDatalayer } from "../../@helpers/js/datalayer.js";
import { findSelection } from "../../@helpers/js/radiogroup-helper.js";

function ClustergridFilter(element) {
	if (!element) {
		return;
	}

	const filterGroup = element.querySelector('[data-clustergrid-filter]');
	const clustergridItems = [...element.querySelectorAll('[data-clustergrid-item]')];

	if (filterGroup && clustergridItems) {
		const filters = [...filterGroup.querySelectorAll('input')];
		const useFilter = () => {
			let filter = findSelection(filters);
			if (filter) {
				clustergridItems.forEach(cgi => {
					if (cgi.dataset?.filter?.indexOf(filter.value) === -1) {
						cgi.hidden = true;
					} else {
						cgi.hidden = false;
					}
				})
				if (filter.hasAttribute('data-slug')) {
					let currentState = history.state;
					let slug = filter.dataset.slug;
					if (slug) {
						history.replaceState(currentState, null, `#${slug.toLowerCase()}`);
					} else {
						history.replaceState(currentState, null, ' ');
					}
				}
				addEventToDatalayer({
					event: 'event',
					category: 'button click',
					action: filter.innerText?.replace(/(\r\n\t|\n|\r\t)/gm, "")?.replace(/ +(?= )/g, '')?.trim() || '',
					label: location.href
				})
			}
		}
		filterGroup.addEventListener('change', () => {
			useFilter();
		})
		
		function getHashFromString(str) {
			if (!str || typeof str !== 'string') {
				return '';
			}
			return str.substring(str.indexOf('#') + 1);
		}
		
		const hashOnLoad = getHashFromString(decodeURI(location.hash)).toLowerCase();
		if (hashOnLoad) {
			const startfilter = filters.find(f => f?.dataset?.slug?.toLowerCase() === hashOnLoad);
			if (startfilter) {
				startfilter.checked = true;
			} else {
				return;
			}
		}
		
		useFilter();
	}
}
export default ClustergridFilter;